import {useMemo} from 'react';

import {useAppSelector} from 'hooks';

export const useAppliedOmniChannelVoucher = () => {
  const {basket, omniChannelsVoucherRedemptionEnabled} = useAppSelector((state) => state?.basket);
  const appliedVoucherPromotion = basket?.appliedVoucherPromotion;

  return useMemo(() => {
    if (!omniChannelsVoucherRedemptionEnabled || !appliedVoucherPromotion) {
      return;
    }
    return appliedVoucherPromotion[0];
  }, [appliedVoucherPromotion, omniChannelsVoucherRedemptionEnabled]);
};
